var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99996 11.3346C5.88947 11.3346 5.7839 11.2889 5.70829 11.2083L0.883293 6.38333C0.804413 6.3051 0.760044 6.1986 0.760044 6.0875C0.760044 5.9764 0.804413 5.8699 0.883293 5.79167L1.04996 5.625C1.12836 5.54362 1.23697 5.49836 1.34996 5.5H3.49996V0.916667C3.49996 0.686548 3.68651 0.5 3.91663 0.5H8.08329C8.31341 0.5 8.49996 0.686548 8.49996 0.916667V5.5H10.65C10.7629 5.49836 10.8716 5.54362 10.95 5.625L11.1166 5.79167C11.1955 5.8699 11.2399 5.9764 11.2399 6.0875C11.2399 6.1986 11.1955 6.3051 11.1166 6.38333L6.29163 11.2083C6.21602 11.2889 6.11045 11.3346 5.99996 11.3346ZM11.8333 14.25V13.4167C11.8333 13.1865 11.6467 13 11.4166 13H0.583293C0.353174 13 0.166626 13.1865 0.166626 13.4167V14.25C0.166626 14.4801 0.353174 14.6667 0.583293 14.6667H11.4166C11.6467 14.6667 11.8333 14.4801 11.8333 14.25Z",
    fill: "#1E40AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.a53e4d4caaf135157f6149e272d68afd.svg";
export { ForwardRef as ReactComponent };